import { useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
export const DEFAULT_LOGO = "/brand/logo.png";

/** Platform logo: uploaded logo (Ajustes → Logo) with fallback to the bundled OOMINING logo. */
export const BrandLogo = ({ version, className = "h-10", testid = "brand-logo" }) => {
  const [failed, setFailed] = useState(false);
  const src = failed || !version ? DEFAULT_LOGO : `${API}/api/settings/app-logo?v=${encodeURIComponent(version)}`;
  return (
    <img src={src} alt="Logo" onError={() => setFailed(true)}
      className={`${className} w-auto max-w-full object-contain select-none`} draggable={false} data-testid={testid} />
  );
};
